(ns guidebook.views.balance-sheet
  (:import
   [goog.i18n NumberFormat])
  (:require
   [guidebook.common :as gc]
   [util.core :refer [valid-date?]]
   [very.re-frame.core :as rf]
   [goog.i18n.NumberFormat]
   [cljss.core :as cljss]
   [css.vars :as vars]
   [css.core :refer [defstyled get-theme]]))

(defstyled balance-sheet-s :div
  {:min-height "100vh"
   :padding "135px 100px"
   :display "grid"
   :grid-template-columns "1fr 1fr"
   :position "relative"
   ::cljss/media {[:print]
                  {:display "none"}}})

(def formatter (NumberFormat. (.-CURRENCY (.-Format NumberFormat))))

(defn retirement-rows [[type value]]
  (let [label (condp = type
                :four-01 "401k, 403b, 457, TSP"
                :roth "Roth"
                :ira "IRA"
                :other "Other")]
    [gc/make-row {:label label
                  :value (.format formatter value)
                  :nested? true}]))

(defn non-retirement-rows [[type value]]
  (let [label (condp = type
                :brokerage "Brokerage accounts (including joint) "
                :utma "529 or UTMA accounts"
                :other "Other")]
    [gc/make-row {:label label
                  :value (.format formatter value)
                  :nested? true}]))

(defn additional-rows [[type value]]
  (let [label (condp = type
                :bank "Bank accounts"
                :homes "Homes and real estate"
                :private "Privately held businesses")]
    [gc/make-row {:label label
                  :value (.format formatter value)
                  :nested? true}]))

(defn assets-table []
  (fn [{:keys [retirement non-retirement additional total-assets]}]
    [gc/table-s
     [gc/header-row-s
      [gc/header-s "Assets"]
      [gc/header-s "Total"]]
     (when retirement
       [:div
        [gc/sub-header-s "Retirement Assets"]
        (into [:div] (map retirement-rows retirement))])
     (when non-retirement
       [:div
        [gc/sub-header-s "Non-Retirement Assets"]
        (into [:div] (map non-retirement-rows non-retirement))])
     (when additional
       [:div
        [gc/sub-header-s "Additional Assets"]
        (into [:div] (map additional-rows additional))])
     [gc/total-row-s
      [gc/header-s "Total Assets"]
      [gc/header-s (.format formatter total-assets)]]]))

(defn liabilities-rows [[type value]]
  (let [label (condp = type
                :outstanding "Outstanding Debts")]
    [gc/make-row {:label label
                  :value (.format formatter value)}]))

(defn liabilities-table []
  (fn [{:keys [liabilities total-liabilities]}]
    [gc/table-s
     [gc/header-row-s
      [gc/header-s "Liabilities"]
      [gc/header-s "Total"]]
     (into [:div] (map liabilities-rows liabilities))
     [gc/total-row-s
      [gc/header-s "Total Liabilities"]
      [gc/header-s {:color vars/red} (.format formatter total-liabilities)]]]))

(defn main []
  (let [data (rf/subscribe [:guidebook/balance-sheet])
        last-updated (rf/subscribe [:guidebook/updated-at])]
    (fn []
      (let [net-worth (:net-worth @data)]
        [balance-sheet-s
         [:div
          [gc/title-s {:max-width "450px"} "Balance Sheet"]
          [gc/body-s "Use your personal balance sheet to keep track of all of your assets and liabilities in one spot."]
          [assets-table @data]
          [liabilities-table @data]
          [gc/net-worth-row-s {:margin "4rem 0 0"
                               :border-color "transparent"}
           [gc/net-worth-header-s "Net Worth"]
           [gc/net-worth-header-s {:color (if (< net-worth 0) vars/red vars/green)} (.format formatter net-worth)]]]
         (when (valid-date? @last-updated)
           [gc/updated-s (str "Last updated on " (gc/format-date @last-updated))])]))))
